// extracted by mini-css-extract-plugin
export default {"plan":"plan_plan__N7L0I","planTitle":"plan_planTitle__Z8Uiu","planListItem":"plan_planListItem__0RYjz"};